
















































import Vue from 'vue';
import store from '@/store';
import { AuthStatus } from '@/store/auth';

export default Vue.extend({
  name: 'SetName',

  props: {
    targetUrl: {
      type: String,
      default: '/'
    }
  },

  data(): { name: string } {
    return {
      name: ''
    };
  },

  computed: {
    status(): AuthStatus {
      return store.state.auth.authStatus;
    },
    showSpinner(): boolean {
      return this.status === AuthStatus.IN_PROGRESS;
    },
    showError(): boolean {
      return this.status === AuthStatus.FAILURE;
    }
  },

  methods: {
    async submitName() {
      if (!this.name || this.name.trim() === '') return;

      await store.dispatch.auth.setUserName(this.name.trim());

      if (this.status !== AuthStatus.FAILURE) {
        const nextUrl =
          this.targetUrl === '/' || this.targetUrl === '/set-name'
            ? '/secure/orgs'
            : this.targetUrl;
        this.$router.push(nextUrl);
      }
    }
  }
});
